import { normalizeRetentionCountries } from './retentionCountries';

export const DASHBOARD_RETENTION_COUNTRIES_STORAGE_KEY = 'womanalytics.dashboard.retentionCountries';

export function readPersistedRetentionCountries(): string[] {
  if (typeof window === 'undefined') return ['Tüm Ülkeler'];
  try {
    const raw = localStorage.getItem(DASHBOARD_RETENTION_COUNTRIES_STORAGE_KEY);
    if (raw == null || raw === '') return ['Tüm Ülkeler'];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed) || !parsed.every((x) => typeof x === 'string')) {
      return ['Tüm Ülkeler'];
    }
    return normalizeRetentionCountries(parsed);
  } catch {
    return ['Tüm Ülkeler'];
  }
}

export function resetDashboardRetentionCountriesStorage(): boolean {
  try {
    localStorage.removeItem(DASHBOARD_RETENTION_COUNTRIES_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}
